import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

/**
 * @name file-heart
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTQgMnY0YTIgMiAwIDAgMCAyIDJoNCIgLz4KICA8cGF0aCBkPSJNMi42MiAxMy44QTIuMjUgMi4yNSAwIDEgMSA2IDEwLjgzNmEyLjI1IDIuMjUgMCAxIDEgMy4zOCAyLjk2NmwtMi42MjYgMi44NTZhLjk5OC45OTggMCAwIDEtMS41MDcgMHoiIC8+CiAgPHBhdGggZD0iTTQgNi4wMDVWNGEyIDIgMCAwIDEgMi0yaDlsNSA1djEzYTIgMiAwIDAgMS0yIDJINmEyIDIgMCAwIDEtMS45LTEuMzc2IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/file-heart
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const FileHeart: IconNode = [
  ['path', { d: 'M14 2v4a2 2 0 0 0 2 2h4' }],
  [
    'path',
    {
      d: 'M2.62 13.8A2.25 2.25 0 1 1 6 10.836a2.25 2.25 0 1 1 3.38 2.966l-2.626 2.856a.998.998 0 0 1-1.507 0z',
    },
  ],
  ['path', { d: 'M4 6.005V4a2 2 0 0 1 2-2h9l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-1.9-1.376' }],
];

export default FileHeart;
